<template>
  <div class="container">
    <h1 class="mb-4">{{ attachment.contract_folio }} Anexo {{ attachment.attachment_id }}</h1>

    <div class="details">
      <div class="details__head">
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item tabs-item">
            <a class="nav-link active" data-toggle="tab" role="tab" href="#details"><fai icon="info"/>
              &nbsp;Generales
            </a>
          </li>
          <li class="nav-item tabs-item">
            <a class="nav-link" data-toggle="tab" role="tab" href="#promissories"><fai icon="file-contract"/>
              &nbsp;Pagarés
            </a>
          </li>
        </ul>
      </div>
      <div class="details__body mt-4">
        <div class="tab-content">
          <!--begin: Details -->
          <div id="details" class="tab-pane fade show active" role="tabpanel">
            <div class="row">
              <div class="col-sm-6">
                <h4 class="m--font-info">Datos Generales</h4>
              </div>
              <div class="col-sm-6 text-right">
                <button class="btn btn-secondary" @click="$router.go(-1)">
                  <fai icon="reply"/> Regresar
                </button>
                <button class="btn btn-info" v-if="state" @click="goToEdit">
                  <fai :icon="['far','edit']"/> Editar
                </button>
                <button class="btn btn-danger" @click="deleteAttachment">
                <fai icon="trash"/> Cancelar
              </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-4">
                  <h5>Acreedor</h5>
                  <span>{{ attachment.investor_name }}</span>
              </div>
              <div class="col-sm-4">
                  <h5>Folio contrato</h5>
                  <span>{{ attachment.contract_folio }}</span>
              </div>
              <div class="col-sm-4">
                  <h5>Tasa de interés</h5>
                  <span>{{ attachment.interest_rate }}%</span>
              </div>
            </div>
            <div class="row mt-4">
                <div class="col-sm-4">
                    <h5>Fecha de inicio</h5>
                    <span>{{ attachment.date_start | formatDate }}</span>
                </div>
                <div class="col-sm-4">
                    <h5>Fecha de pago</h5>
                    <span>{{ attachment.date_init }}</span>
                </div>
                <div class="col-sm-4">
                    <h5>Fecha de vencimiento</h5>
                    <span>{{ attachment.date_expire }}</span>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-sm-4">
                    <h5>Día de corte</h5>
                    <span>Día {{ attachment.cut_day }}</span>
                </div>
                <div class="col-sm-4">
                    <h5>Monto</h5>
                    <span>{{ attachment.amount | formatCurrency }}</span>
                </div>
                <div class="col-sm-4">
                    <h5>Tipo</h5>
                    <span>{{ attachment.type }}</span>
                </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-4">
                  <h5>Frecuencia de pago</h5>
                  <span>{{ attachment.frequency }}</span>
              </div>
              <div class="col-sm-4">
                  <h5>Estatus</h5>
                  <span>{{ attachment.state || 'No asignado' }}</span>
              </div>
            </div>
            <hr class="mt-4"/>
            <div class="row">
              <div class="col-sm col-md col-lg">
                <h4 class="m--font-info">Anexo</h4>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-4">
                <a class="btn btn-info" @click="getFileUrl(attachment.id)">Descargar Anexo</a>
                <h5>Subir formato firmado</h5>
                <vue-dropzone
                  ref="attachmentDropzone"
                  @vdropzone-success="successDropzone"
                  id="dropzone"
                  :options="dropzoneOptions">
                </vue-dropzone>
              </div>
            </div>
            <hr class="mt-4"/>
            <div class="row">
                <div class="col-sm col-md col-lg">
                    <h4 class="m--font-info">Registro</h4>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-sm-4">
                    <h5>Registrado por</h5>
                    <span>{{ attachment.created_by }}</span>
                </div>
                <div class="col-sm-4">
                    <h5>Fecha de creación en el sistema</h5>
                    <span>{{ attachment.created_at }}</span>
                </div>
                <div class="col-sm-4">
                    <h5>Fecha de cancelación</h5>
                    <span>{{ attachment.cancelled_at }}</span>
                </div>
            </div>
          </div>
          <!--end: Details -->
          <!--begin: Promissories -->
          <div id="promissories" class="tab-pane fade" role="tabpanel" v-if="attachment.id">
            <sys-table
              title="Pagarés"
              :headers="promissory_headers"
              :items="attachment.promissories"
              create_route="attachment_create_promissory"
              :create_route_params="{id: attachment.id}"
              title_icon="file-contract"
              :custom_action="cancelPromissory"
              :custom_action_condition="displayCancelButton"
              custom_action_icon="times"
              :custom_action2="editPromissory"
              error_message="No se encontraron pagarés"/>
          </div>
          <!--end: Promissories -->
        </div>
      </div>
      <cancel-attachment-promissory v-if="promissory_to_cancel" :promissory="promissory_to_cancel"
                                    @promissoryCancelled="onPromissoryCancelled">
      </cancel-attachment-promissory>
      <edit-attachment-promissory v-if="promissory_to_edit" :promissory="promissory_to_edit"
                                    @promissoryEdited="onPromissoryEdited">
      </edit-attachment-promissory>
    </div>
  </div>
</template>

<script>
import * as $ from 'jquery'
import SysTable from '@/components/shared/Table'
import attachmentsService from '@/services/attachments'
import CancelAttachmentPromissory from './CancelAttachmentPromissory'
import EditAttachmentPromissory from './EditAttachmentPromissory'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import apiConfig from '@/services/api-config'
import store from '@/store'

export default {
  name: 'AttachmentDetail',

  components: { CancelAttachmentPromissory, EditAttachmentPromissory, SysTable, vueDropzone: vue2Dropzone },

  data () {
    return {
      state: true,
      attachment: { amount: 0, promissories: [] },
      promissory_to_cancel: { folio: '', id: '' },
      promissory_to_edit: { folio: '', id: '' },
      promissory_headers: [
        { text: 'Folio de pagaré', value: 'folio' },
        { text: 'Estatus', value: 'status' },
        { text: 'Motivo de Cancelación', value: 'cancel_reason' },
        { text: 'Comprobante', value: 'file_url', link: false, statement: true, class: 'text-center' }
      ],
      bank_data_headers: [
        { text: 'Id', value: 'bank_data_id' },
        { text: 'Cuenta Habiente', value: 'holder' },
        { text: 'Banco', value: 'bank' },
        { text: 'Cuenta', value: 'account' },
        { text: 'CLABE', value: 'clabe' }
      ],
      bank_data: [],
      contacts_headers: [
        { text: 'Nombre', value: 'name' },
        { text: 'Correo electrónico', value: 'email' },
        { text: 'Celular', value: 'telephone' },
        { text: 'Teléfono', value: 'mobile' },
        { text: 'Puesto', value: 'role' }
      ],
      contacts: [],
      investments_headers: [
        { text: 'Nombre', value: 'name' },
        { text: 'Correo electrónico', value: 'email' },
        { text: 'Celular', value: 'telephone' },
        { text: 'Teléfono', value: 'mobile' },
        { text: 'Puesto', value: 'role' }
      ],
      investments: [],
      monthly_cuts_headers: [
        { text: 'Nombre', value: 'name' },
        { text: 'Correo electrónico', value: 'email' },
        { text: 'Celular', value: 'telephone' },
        { text: 'Teléfono', value: 'mobile' },
        { text: 'Puesto', value: 'role' }
      ],
      monthly_cuts: [],
      dropzoneOptions: {
        url: `${apiConfig.apiUrl}/attachment/${this.$route.params.id}/document`,
        headers: {
          Authorization: store.getters.getToken
        },
        maxFiles: 1
      }
    }
  },
  created: function () {
    // this.state = false
    const id = this.$route.params.id
    let element = this.$store.getters.getSelectedElement

    if (element.type === 'attachment' && element.data.id === id) this.attachment = element.data
    else {
      // attachmentsService.checkCuts(id).then(res => {
      //   this.state = res.data
      // })

      attachmentsService.getById(id, {include: 'promissories'}).then(res => {
        this.attachment = res.data
      })
    }
  },
  methods: {
    goToEdit () {
      const id = this.attachment.id
      this.$router.push({ name: 'attachment_update', params: { id } })
    },
    getFileUrl (id) {
      attachmentsService.getFileUrl(id).then(res => {
        if (res.error) {
          this.error = res.error
        } else {
          this.error = null
          window.open(res.url, '_blank')
        }
      }).catch(err => {
        console.log(JSON.stringify(err.data))
      })
    },
    successDropzone (file, response) {
      this.$refs.attachmentDropzone.removeAllFiles()
      this.attachment.file_url = response.file_url
    },
    cancelPromissory (item) {
      if (item.status === 'Cancelado') {
        return
      }
      this.promissory_to_cancel = item
      this.promissory_to_cancel.id = item.id
      $('#cancel-attachment-promissory').modal()
    },
    editPromissory (item) {
      this.promissory_to_edit = item
      this.promissory_to_edit.id = item.id
      $('#edit-attachment-promissory').modal()
    },
    onPromissoryEdited () {
      window.location.reload()
    },
    displayCancelButton (item) {
      return item.status !== 'Cancelado'
    },
    onPromissoryCancelled () {
      window.location.reload()
    },
    deleteAttachment () {
      const id = this.$route.params.id

      this.$swal({
        title: 'Deseas cancelar el anexo?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((willDelete) => {
        if (willDelete) {
          attachmentsService.deleteById(id).then(res => {
            this.$swal('El Anexo ha sido cancelado, no se tomará en cuenta para los siguientes cortes.', {
              icon: 'success'
            })
            this.$router.go(-1)
          }).catch(err => {
            this.$swal(err.message, 'Favor de intentar nuevamente', {
              icon: 'error'
            })
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/attachments/AttachmentDetail.vue